/** Hint inside an empty date field: the one order the portal reads and writes. */
export const US_DATE_PLACEHOLDER = 'MM/DD/YYYY';

/** Name of the button beside a date field that opens the calendar, naming the field when it has a name. */
export function calendarLabel(fieldName: string | undefined): string {
  return fieldName === undefined ? 'Choose date' : `Choose date for ${fieldName}`;
}
